import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { updateFlexMatchRequestDutyCodeAndFunction } from 'RestAPIs/flex-match';

export type UpdateFlexMatchRequestDutyCodeAndFunction = {
  requestId: number;
  body: {
    dutyId: number;
    functionId: string;
  };
};

const useUpdateFlexMatchRequestDutyCodeAndFunction = ({
  isWebSocketUpdate = false
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: UpdateFlexMatchRequestDutyCodeAndFunction) =>
      updateFlexMatchRequestDutyCodeAndFunction(payload),
    {
      onSuccess: () => {
        !isWebSocketUpdate && queryClient.invalidateQueries(['flexMatchTasks']);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useUpdateFlexMatchRequestDutyCodeAndFunction;
